var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Category3",
                                      prop: "category3Code",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.category3Code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "category3Code",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.category3Code",
                                        },
                                      },
                                      _vm._l(
                                        _vm.category3List,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.object,
                                              value: item.key,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Sponsor",
                                      prop: "sponsorName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.sponsorName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "sponsorName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.sponsorName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Farm", prop: "farmName" },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.farmName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "farmName",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.farmName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Farm Group",
                                      prop: "farmGroup",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.farmGroup,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "farmGroup",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.farmGroup",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "商品名",
                                              prop: "productName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .productName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "productName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.productName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "用途分类",
                                              prop: "useClass",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.useClass,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "useClass",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.useClass",
                                                },
                                              },
                                              _vm._l(
                                                _vm.useClassList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "有效成分",
                                              prop: "effectiveComponentsList",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  filterable: "",
                                                  clearable: "",
                                                  multiple: "",
                                                  "collapse-tags": "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .effectiveComponentsList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "effectiveComponentsList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.effectiveComponentsList",
                                                },
                                              },
                                              _vm._l(
                                                _vm.effectiveComponentsList,
                                                function (item, index) {
                                                  return _c(
                                                    "el-option",
                                                    {
                                                      key: index,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.code,
                                                      },
                                                    },
                                                    [
                                                      item.name.length > 20
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  item.name,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    display:
                                                                      "inline-block",
                                                                    width:
                                                                      "300px",
                                                                    overflow:
                                                                      "hidden",
                                                                    "white-space":
                                                                      "nowrap",
                                                                    "text-overflow":
                                                                      "ellipsis",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display:
                                                                  "inline-block",
                                                                width: "300px",
                                                                overflow:
                                                                  "hidden",
                                                                "white-space":
                                                                  "nowrap",
                                                                "text-overflow":
                                                                  "ellipsis",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "药品状态",
                                              prop: "medicineUseStatus",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table:
                                                  "TT_RMC_PRODUCE_MEDICINE",
                                                filterable: "",
                                                field: "MEDICINE_USE_STATUS",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .medicineUseStatus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "medicineUseStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.medicineUseStatus",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "审批状态",
                                              prop: "status",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                  filterable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.status",
                                                },
                                              },
                                              _vm._l(
                                                _vm.statusOption,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.chineseValue,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryData(1)
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDICINE_ADD,
                    expression: "RMC_PROD_MEDICINE_ADD",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.addList },
              },
              [_vm._v("新增")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDICINE_DELETE,
                    expression: "RMC_PROD_MEDICINE_DELETE",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "danger" },
                on: { click: _vm.onDel },
              },
              [_vm._v("删除")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDICINE_SUBMIT,
                    expression: "RMC_PROD_MEDICINE_SUBMIT",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.submit },
              },
              [_vm._v("提交")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDICINE_CONFIRM,
                    expression: "RMC_PROD_MEDICINE_CONFIRM",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.isUpdate },
              },
              [_vm._v("确认无更新")]
            ),
            _c(
              "el-dropdown",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDICINE_REPORT,
                    expression: "RMC_PROD_MEDICINE_REPORT",
                  },
                ],
                staticStyle: { "margin-right": "10px" },
                attrs: {
                  "split-button": "",
                  type: "primary",
                  placement: "bottom",
                },
                on: { click: _vm.handleClick },
              },
              [
                _vm._v(" 报表 "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "el-dropdown-item",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.RMC_PROD_MEDICINE_REPORT,
                                expression: "RMC_PROD_MEDICINE_REPORT",
                              },
                            ],
                            staticClass: "dropdownItemBtn",
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.exportMedicine },
                          },
                          [_vm._v("药品清单")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-dropdown-item",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.RMC_PROD_MEDICINE_REPORT_QUR,
                                expression: "RMC_PROD_MEDICINE_REPORT_QUR",
                              },
                            ],
                            staticClass: "dropdownItemBtn",
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.exportSnapshot },
                          },
                          [_vm._v("药品清单(季度)")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDICINE_IMPORT,
                    expression: "RMC_PROD_MEDICINE_IMPORT",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.importData },
              },
              [_vm._v("批量导入")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDICINE_HISTORY,
                    expression: "RMC_PROD_MEDICINE_HISTORY",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.openHistory },
              },
              [_vm._v("查看历史")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDICINE_CHANGE_LOG,
                    expression: "RMC_PROD_MEDICINE_CHANGE_LOG",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.updateLog },
              },
              [_vm._v("更新日志")]
            ),
          ],
          1
        ),
        _c(
          "ux-grid",
          {
            ref: "plxTable",
            attrs: {
              data: _vm.tableData,
              "max-height": "500",
              "show-overflow": "tooltip",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.selectionChange },
          },
          [
            _c("ux-table-column", {
              attrs: {
                align: "center",
                type: "checkbox",
                width: "80",
                fixed: "left",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Category3",
                fixed: "left",
                field: "category3Name",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Sponsor",
                fixed: "left",
                "min-width": "100",
                field: "sponsorName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Farm",
                fixed: "left",
                "min-width": "120",
                field: "farmName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Farm Group",
                fixed: "left",
                "min-width": "120",
                field: "farmGroup",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "商品名",
                fixed: "left",
                "min-width": "140",
                field: "productName",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.goDetail(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.productName))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "有效成分",
                fixed: "left",
                "min-width": "120",
                field: "effectiveComponents",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "用途分类",
                "min-width": "100",
                field: "useClass",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "作物名称",
                "min-width": "120",
                field: "cultiVarName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "含量",
                "min-width": "120",
                field: "contents",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "安全间隔期/天",
                "min-width": "120",
                field: "safetyDay",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "生产厂家",
                "min-width": "120",
                field: "producer",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "剂型",
                "min-width": "120",
                field: "dosageForm",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "使用方法",
                "min-width": "120",
                field: "usage",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "指导用量",
                "min-width": "120",
                field: "guideUsage",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "最多使用次数/季",
                "min-width": "120",
                field: "maximum",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "农药登记证号",
                "min-width": "120",
                field: "pesticideNumber",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "GB 2763",
                "min-width": "120",
                field: "finiteQuantity",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "其他标准",
                "min-width": "120",
                field: "otherStandard",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "修改原因",
                "min-width": "120",
                field: "modifyReason",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "药品在用状态",
                "min-width": "120",
                field: "medicineUseStatusI18n",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "状态",
                "min-width": "120",
                field: "statusI18n",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "提交人",
                "min-width": "120",
                field: "submitUser",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "提交日期",
                "min-width": "120",
                field: "submitDate",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.dialogVisible,
              width: "60%",
              "before-close": _vm.handleClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("更新日志 "),
                    ]),
                  ]
                ),
              ]
            ),
            _vm.dialogVisible
              ? _c("updateDialog", { on: { close: _vm.handleClose } })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "",
              visible: _vm.exportDialog,
              width: "30%",
              "before-close": _vm.closeExportDialog,
            },
            on: {
              "update:visible": function ($event) {
                _vm.exportDialog = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("选择季度"),
                    ]),
                  ]
                ),
              ]
            ),
            _vm.exportDialog
              ? _c("exportDialog", {
                  attrs: { exportTitle: _vm.exportTitle },
                  on: { closeExport: _vm.closeExportDialog },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "批量导入",
              visible: _vm.dialogBatchUploadVisible,
              width: "40%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogBatchUploadVisible = $event
              },
              close: _vm.onCloseUpload,
            },
          },
          [
            _c(
              "el-row",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _c(
                  "el-upload",
                  {
                    ref: "batchUpload",
                    staticStyle: {
                      display: "inline-block",
                      "margin-right": "10px",
                    },
                    attrs: {
                      headers: _vm.header,
                      action: _vm.uploadListsUrl,
                      "on-success": _vm.uploadListsSuccess,
                      "on-change": _vm.handleChange,
                      "before-upload": _vm.beforeListsUpload,
                      "file-list": _vm.importFileList,
                      "auto-upload": false,
                      "show-file-list": false,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [_vm._v("选取文件")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    staticStyle: { height: "100%" },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadImportTem },
                  },
                  [_vm._v("导入模板下载")]
                ),
              ],
              1
            ),
            _c(
              "el-form",
              { ref: "uploadForm", attrs: { model: _vm.uploadForm } },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.uploadForm.fileName,
                        callback: function ($$v) {
                          _vm.$set(_vm.uploadForm, "fileName", $$v)
                        },
                        expression: "uploadForm.fileName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-row", [
              _c("h4", [_vm._v("说明:")]),
              _c("ul", [
                _c("li", [_vm._v("1.请点击模板下载,按照模板填写后再上传")]),
                _c("li", [_vm._v("2.模板中红色字段为必填项,请务必正确填写")]),
                _c("li", [
                  _vm._v("3.仅支持上传Excel格式文件,且大小不能超过20M"),
                ]),
                _c("li", [
                  _vm._v("4.为保证上传成功,请勿对模板中的单元格进行修改"),
                ]),
                _c("li", [
                  _vm._v("5.一次仅支持一份文件上传,多份文件上传将会替换原文件"),
                ]),
              ]),
            ]),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onUpload },
                  },
                  [_vm._v("上传")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onClose1 },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }